// extracted by mini-css-extract-plugin
export default {"actions":"SimpleDialogContent_actions__wphnS"};